// src/components/WhatsAppButton.jsx
import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./WhatsappButton.css";

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/971585582100"
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-button"
      aria-label="Chatea con nosotros por WhatsApp"
    >
      <FaWhatsapp className="whatsapp-icon" />
    </a>
  );
};

export default WhatsAppButton;